<template>
    <div>
        <div>
            <a href="https://www.ibm.com/quantum">IBM Quantum Computing</a>
            <br />
            <a href="https://qiskit.org/">Qiskit - Open-Source Quantum Development</a>
            <br />
            <a href="https://quantumai.google/">Google Quantum AI - Cirq</a>
            <br />
            <a href="https://aws.amazon.com/what-is/quantum-computing/#:~:text=Quantum%20computing%20is%20a%20multidisciplinary,faster%20than%20on%20classical%20computers">AWS - What Is Quantum Computing?</a>
        </div>
        <br />
        <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/AQjKUN8PORM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <br />
        <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/lt4OsgmUTGI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <br />
        <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/e3fz3dqhN44" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <br />
        <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/OWJCfOvochA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>            
        </div>
    </div>
</template>

<script>
    export default {
        name: 'QuantumDashboard',
        components: {
        },
        data: function () {
            return {
                test: "QuantumDashboard test",
            };
        },
        props: [],
        watch: {},
        methods: {      

        },
        mounted: function () {

        }
    }
</script>

<style scoped>
    
</style>    

